import { Form as AntdForm } from 'antd';
import './styles.less';

export const Form = AntdForm;
